import { CountryEntity } from 'api/types/entity';
import { useStableKeys } from 'hooks';
import { Stack } from 'libs/ui';
import { DocumentsTableFeature } from 'modules/client/common/feature';
import { useFormContext } from 'modules/client/common/forms/taxResidencyForm';

import { Header, Fields } from './components';

export interface FormContentProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  enabledDocuments?: boolean;
  onRemoveTaxResidency?: (index: number) => void;
}

export const FormContent = ({
  countriesLoading,
  countries,
  enabledDocuments,
  onRemoveTaxResidency,
}: FormContentProps) => {
  const { values } = useFormContext();

  const taxResidencesKeys = useStableKeys(values.taxResidences);

  return (
    <Stack spacing={24}>
      {values.taxResidences.map((value, index) => (
        <Stack key={taxResidencesKeys[index]} spacing={24}>
          <Stack spacing={12}>
            <Header index={index} onRemoveTaxResidency={onRemoveTaxResidency} />

            <Fields
              countries={countries}
              countriesLoading={countriesLoading}
              index={index}
              value={value}
            />
          </Stack>
          {enabledDocuments && !value.taxNumberIsMissing && (
            <DocumentsTableFeature name={`taxResidences.${index}.documents`} />
          )}
        </Stack>
      ))}
    </Stack>
  );
};
